//只需修改default以及port

const config = process.env.env || 'dev';
//商户后台 shopPort 严选端口号都是单独的9003   特此说明
const URL = {
    dev:{ host: 'https://devmerchant.yidayuntu.cn', port: '9982' , shopPort: '9003'},
    devres: { host: 'https://res.yidayuntu.cn', port: '9982', shopPort: '9003' },
    dev59: { host: 'http://117.48.209.59', port: '9981', shopPort: '9003' },
    dev112: { host: 'http://114.67.170.112', port: '9981', shopPort: '9003' },
    sitetest: { host: 'https://sitetest.yidayuntu.cn', port: '9982', shopPort: '9003' },
    test: { host: 'https://testsuperapp.yidayuntu.cn', port: '9982', shopPort: '9003'},
    uat: { host: 'https://uat.yidayuntu.cn', port: '9982', shopPort: '9003' },
    demo: { host: 'https://demo.yidayuntu.cn', port: '9982', shopPort: '9003' },
    sit: { host: 'https://test.yidayuntu.cn', port: '9982', shopPort: '9003' },
    gdtontest: { host: 'https://gdton.yidayuntu.cn', port: '9982', shopPort: '9003' },
    gdtonPro: { host: 'https://yzg.kingser.com', port: '9981', shopPort: '9003' },
    prod: { host: 'https://www.yidayuntu.com', port: '9982', shopPort: '9003' },
    prepro: { host: 'https://prepro.yidayuntu.cn', port: '9982', shopPort: '9003' },
    dev114112: { host: 'http://zzcf-dev.yidayuntu.cn', port: '9981', shopPort: '9003' },
    dev114112https: { host: 'https://zzcf-dev.yidayuntu.cn', port: '9982', shopPort: '9003' },
    dev11411test: { host: 'http://114.67.204.11', port: '19981', shopPort: '9003' },
    devydcn: { host: 'https://zgy-dev.yidachina.com', port: '9982', shopPort: '9003' },
    prodydcn: { host: 'https://cy.yidachina.com', port: '9982', shopPort: '9003' },
};

// 获取url
const getUrl = (port = "port")=>{
    let urlObj = URL[config] || URL.dev;
    return `${ urlObj.host }:${ urlObj[port] }`
}

export default {
    default: getUrl("shopPort"),
    project: getUrl()
}
